import { type QueryHookOptions, useQuery } from "@apollo/client";
import { RefundsListQuery } from "../graphql/queries";
import type {
  RefundsListQueryType,
  RefundsListQueryVariablesType,
} from "@/types/graphql/admin.generated";

export const useRefundsQuery = (
  options?: QueryHookOptions<
    RefundsListQueryType,
    RefundsListQueryVariablesType
  >
) => {
  return useQuery<RefundsListQueryType, RefundsListQueryVariablesType>(
    RefundsListQuery,
    options
  );
};
